import { RootState } from '../../store';

export const getTicketIsLoadingSelector = (state: RootState) => state?.ticketReducer?.ticketIsLoading;
